
import React from 'react';

//Graphic section SVG Icons
import { getFileName } from 'helpers/FileCaching';

const graphicIcons = require.context('Assets/GraphicSection/', true, /.*\.(svg)$/i);
const heroGraphicIcons = require.context('Assets/HeroGraphic/', true, /.*\.(svg)$/i);
const DBSData = class {

    static INTRO_PANEL = {
        smallTitle:"The Seven forms of",
        title:"Sustainable Fashion",
        icon:<img alt="seven form of sustainable fashion" src= {getFileName(heroGraphicIcons, 'heroGraphic.svg') }/>
    }

    static ICONS ={

        onDemand:{
            title:"on demamd<br>& custom made",
            description:"Reducing the likelihood of wastage from seasonal collections, as well as ensuring a perfect fit, tailored to the individual.",
            icon:<img alt="on demand and custom made" src= {getFileName(graphicIcons, 'onDemand.svg') }/>
        },

        greenAndClean:{
            title:"green & clean",
            description:"Made in an environmentally friendly manner for all phases of the product’s lifecycle.",
            icon:<img alt="green and clean" src= {getFileName(graphicIcons, 'leaf.svg') }/>
        },
            
        highQualityTimeless:{
            title:"high quality<br>& timeless design",
            description:"With more durable, high quality fabrics and a timeless design it can reduce the need to refresh a wardrobe each season.",
            icon:<img alt="hight quality" src= {getFileName(graphicIcons, 'highQuality.svg') }/>
            
        },

        fairEthical:{
            title:"fair & ethical",
            description:"With consideration for fair trade, animal welfare, working conditions and sustainable production.",
            icon:<img alt="fair and ethical" src= {getFileName(graphicIcons, 'fairEthical.svg') }/>
        },

        repairRedesign:{
            title:"repair, redesign & upcycle",
            description:"Garments should be used long and well through good care, repair and perhaps redesign.",
            icon:<img alt="repair, redesign, upcycle" src= {getFileName(graphicIcons, 'repairRedesign.svg') }/>
        },

        rentLease:{
            title:"Rent, lease & swap",
            description:"Unwanted clothes can be handed in to a second-hand shop, donated to charity or passed on or swapped with friends or family to prolong its active life.",
            icon:<img alt="rent, lease and swap" src= {getFileName(graphicIcons, 'rentLease.svg') }/>
        },

        secondHand:{
            title:"Second hand <br>and vintage",
            description:"Buying second-hand or vintage means no new clothes are made, and further reduces the impact of that one garment purchased.",
            icon:<img alt="second hand and vintage" src= {getFileName(graphicIcons, 'secondHand.svg') }/>
        }

    }
    
}   

export default DBSData;